<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  metaInfo() {
    return {
      meta: [
        // Open Graph协议（百度、微信等支持）
        { property: 'og:image', content: 'https://web.yuntixi.cn/NewsUploads/20250430141034701.png' },
        // Twitter Cards协议
        { name: 'twitter:image', content: 'https://web.yuntixi.cn/NewsUploads/20250430141034701.png' }
      ]
    };
  },
}
</script>